import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result } from '@digibricks/domains';
import { ErrorResultHandler } from '@lib/domain-common';
import { AxiosApi } from '@digibricks/plugin-axios';
import { FolderSummary, FormSummary, ParentFolder, WorkspaceSearchResponse } from '../../../core';
export var WORKSPACE_SEARCH_API = 'WORKSPACE_SEARCH_API';
export var WorkspaceSearchApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(WorkspaceSearchApi, _AxiosApi);

  var _super = _createSuper(WorkspaceSearchApi);

  function WorkspaceSearchApi(axiosInstance) {
    var _this;

    _classCallCheck(this, WorkspaceSearchApi);

    _this = _super.call(this, 'workspace-search', axiosInstance);
    _this.axiosInstance = axiosInstance;
    return _this;
  }

  _createClass(WorkspaceSearchApi, [{
    key: "workspaceSearch",
    value: function () {
      var _workspaceSearch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var url, jsonResponse, parsedResponseBody, _parsedResponseBody$d, forms, folders, parentFolders, formSummaries, folderSummaries, parentFolderSummaries, workspaceSearchResponseProps;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                url = this.url;
                _context.next = 4;
                return this.axios.get(url, {
                  headers: {
                    Authorization: "Bearer ".concat(localStorage.getItem('access_token'))
                  },
                  params: query
                });

              case 4:
                jsonResponse = _context.sent;
                parsedResponseBody = jsonResponse.data;

                if (parsedResponseBody.data) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", Result.fail(parsedResponseBody.message));

              case 8:
                _parsedResponseBody$d = parsedResponseBody.data, forms = _parsedResponseBody$d.forms, folders = _parsedResponseBody$d.folders, parentFolders = _parsedResponseBody$d.parentFolders;
                formSummaries = this.createFormSummaries(forms);
                folderSummaries = this.createFolderSummaries(folders);
                parentFolderSummaries = this.createParentFolderSummaries(parentFolders);
                workspaceSearchResponseProps = {
                  forms: formSummaries,
                  folders: folderSummaries,
                  parentFolders: parentFolderSummaries
                };
                return _context.abrupt("return", WorkspaceSearchResponse.create(workspaceSearchResponseProps));

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", ErrorResultHandler(_context.t0));

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 16]]);
      }));

      function workspaceSearch(_x) {
        return _workspaceSearch.apply(this, arguments);
      }

      return workspaceSearch;
    }()
  }, {
    key: "createFormSummaries",
    value: function createFormSummaries(formSummariesProps) {
      return formSummariesProps.map(function (props) {
        var formSummary = FormSummary.create(props).getValue();
        formSummary.updatedAt = props.updatedAt;
        return formSummary;
      });
    }
  }, {
    key: "createFolderSummaries",
    value: function createFolderSummaries(folderSummariesProps) {
      return folderSummariesProps.map(function (props) {
        var folderSummary = FolderSummary.create(props).getValue();
        return folderSummary;
      });
    }
  }, {
    key: "createParentFolderSummaries",
    value: function createParentFolderSummaries(parentFolderProps) {
      return parentFolderProps.map(function (parentFolder) {
        return ParentFolder.create(parentFolder).getValue();
      });
    }
  }]);

  return WorkspaceSearchApi;
}(AxiosApi);